export const defaultOrder = {
  customer: {
    id: '',
    type: '',
    email: '',
    address: {}
  },
  customerRef: '',
  status: 'Pending',
  type: 'retail',
  subtotal: 0,
  items: {},
  shipping: {
    amount: 0,
    method: ''
  },
  shipments: [],
  notes: '',
  messages: [],
  payments: {}
}
